<template>
  <div>
    <div class="donut-chart" v-if="total > 0" ref="donut_chart">
    </div>
  </div>
</template>
<script>
import Chartist from 'chartist'


export default {
  props: ['series', 'total'],
  methods: {
    init(){
      let labels = this.labels()
      if(labels.length > 0){
        new Chartist.Pie(this.$refs.donut_chart, {
          series: this.series,
          labels
        }, {
          donut: true,
          donutWidth: 55,
          donutSolid: true,
          startAngle: 270,
          showLabel: true
        });
      }
    },
    labels(){
      let labels =[]
      let series = this.series
      let total = this.total
      series.forEach((number,key) => {
        if(number === undefined){
          return false
        }
        if(number === 0){
          labels[key] = " "
        }else{
          let result = (number / total) * 100
          labels[key] = Math.round(result) + "%"
        }
      });
      return labels
    }
  },
  mounted(){
    this.init()
  },
  computed: {

  },
  watch: {
    series(){
      this.init()
    }
  }
}  
</script>




// WEBPACK FOOTER //
// DonutChart.vue?5b7dc7ee